import React from 'react';
import { BoxPanel } from '../BoxPanel/BoxPanel';

export type SuccessPageProps = {
  title?: string;
  message?: string;
  icon: 'succeed' | 'failed' | 'pending';
  action?: React.ReactNode;
};

export const SuccessPage: React.FC<SuccessPageProps> = (
  props: SuccessPageProps,
) => {
  const { title, message, icon } = props;

  return (
    <div>
      <BoxPanel
        icon={icon}
        title={title}
        description={message}
        sx={{
          marginTop: '20px',
          marginBottom: '20px',
        }}
      />
      {props.action}
    </div>
  );
};
